export const dialog = {
  colorScheme: {
    light: {
      background: '{surface.100}',
      // background: 'red',
      borderColor: '{primary.400}',
      color: '{text.color}',
      navButton: {
        color: 'black',
        selectedColor: 'black',
      },
    },
    dark: {
      // background: 'red',
      background: '#333643',
      borderColor: '{primary.400}',
      currentPageReportColor: '#aeb5b7',
      color: 'white',
      navButton: {
        color: '#ffffff',
        selectedColor: '#ffffff',
      },
    },
  },
};
